export { SectionBadge } from "./SectionBadge";
export { SectionBadgeVariants } from "./SectionBadge.style";
